import s from './Footer.module.css'
import {Container} from "../../../common/container/Container";
import {NavLink} from "react-router-dom";
import {footerPages} from "../../../utils/data/footerData";
import {useTranslation} from "react-i18next";
import {HeaderLogo} from "../../header/headerLogo/HeaderLogo";
import {RoutePath} from "../../../router/routerConfig/routerConfig";
import {goToTop} from "../../../utils/helpers/goToTop";
import {useCallback} from "react";

export const Footer = () => {
    const {t, i18n} = useTranslation(['footer'])

    const onClickHandler = useCallback(() => {
        goToTop('auto')
    }, [])

    return (
        <footer className={s.footer}>
            <Container variant={'noVerticalPadding'}>
                <div className={s.footer__topLine}>
                    <HeaderLogo className={s.footer__logoLink}/>
                    <div className={s.topLineMenu}>
                        <NavLink
                            to={RoutePath.about}
                            className={s.topLineMenu__link}
                            onClick={onClickHandler}
                        >
                            {t('about')}
                        </NavLink>
                        <NavLink
                            to={RoutePath.mission}
                            className={s.topLineMenu__link}
                            onClick={onClickHandler}
                        >
                            {t('ourMission')}
                        </NavLink>
                    </div>
                </div>

                <div className={s.footer__bottomLine}>
                    <div className={s.footer__copyright}>
                        OpenHalt © {new Date().getFullYear()}
                    </div>

                    <div className={s.bottomLineMenu}>
                        {footerPages.map((page) => {
                            const href = typeof page.path === 'function' ? page.path(i18n.language) : page.path
                            return page.isExternal
                                ? <a key={page.translationKey} href={href} onClick={onClickHandler} className={s.bottomLineMenu__link}>{t(`titles.${page.translationKey}`)}</a>
                                : <NavLink key={page.translationKey} to={href} onClick={onClickHandler} className={s.bottomLineMenu__link}>{t(`titles.${page.translationKey}`)}</NavLink>
                        })}

                    </div>
                </div>

            </Container>
        </footer>
    );
};
